var voted_users_rtlignore_default = {
  "container": "dpFEj",
  "webview": "Gb6i0",
  "avatar_list": "trjM1",
  "avatar": "_5VrKO",
  "user_avatar": "Yzd6r",
  "modal": "ieogs",
  "voted_users_modal": "P0o--",
  "overlay": "_1hFGP",
  "user_card": "dlB-z",
  "user_name": "TeaO4",
  "voted_users_modal_header": "_34ixf",
  "cta": "cl6Xt",
  "close_icon": "fx7FX",
  "title": "rVr-R",
  "member_list_container": "kfxTG",
  "member_list": "rF3Ft",
  "loader": "aHJpp",
  "anonymous_counter": "_4yiqM",
  "spinner": "Wad8V",
  "spin": "VluJc"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
